import psiData from "./models/psi";

export default {
	psiData
};